import { IsNumber, IsString } from 'class-validator';

export class GiftCardCheckResponse {
  constructor(cardNumber: string, balance: number) {
    (this.cardNumber = cardNumber), (this.balance = balance);
  }

  @IsString()
  cardNumber: string;

  @IsNumber()
  balance: number;

  @IsString()
  typeName: string;

  @IsString()
  photoURL: string;
}
